"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[133],{

/***/ 5133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ charge_station_ChargeStation; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/base/gridview/index.tsx + 4 modules
var gridview = __webpack_require__(7923);
// EXTERNAL MODULE: ./components/base/image/Image.tsx
var Image = __webpack_require__(4297);
;// CONCATENATED MODULE: ./components/widgets/charge-station/ChargeStation.tsx




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ChargeStation = function(param) {
    var title = param.title, subTitle = param.subTitle, image = param.image, children = param.children;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "charge-station section text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Container */.W2, {
            size: "medium",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                    xs: {
                        align: 'center'
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                        xs: {
                            size: 12
                        },
                        sm: {
                            size: 12
                        },
                        md: {
                            size: 12
                        },
                        lg: {
                            size: 12
                        },
                        xl: {
                            size: 12
                        },
                        className: "text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "section-title",
                            children: [
                                title,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: subTitle
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                        xs: {
                            size: 12
                        },
                        sm: {
                            size: 12
                        },
                        md: {
                            size: 12
                        },
                        lg: {
                            size: 12
                        },
                        xl: {
                            size: 12
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, _objectSpread({}, image, {
                                alt: ""
                            }))
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                    className: "children",
                    children: children
                })
            ]
        })
    }));
};
/* harmony default export */ var charge_station_ChargeStation = (ChargeStation);

;// CONCATENATED MODULE: ./components/widgets/charge-station/index.tsx



/***/ })

}]);